import { fetchTradeDataByTradeFormId } from "../api/trade";
import {
  STATUS_APPROVED,
  STATUS_CANCELED_ADM,
  STATUS_CANCELED_EE,
  STATUS_CANCEL_DECLINED,
  STATUS_CANCEL_EXPIRED_ADM,
  STATUS_CANCEL_EXPIRED_EE,
  STATUS_CANCEL_OFFERED,
  STATUS_CANCEL_REFUSED,
  STATUS_CANCEL_SUBMITTED,
  STATUS_DECLINED,
  STATUS_EXPIRED_ADM,
  STATUS_EXPIRED_EE,
  STATUS_OFFERED,
  STATUS_REFUSED,
  STATUS_RETRACTED,
  STATUS_SUBMITTED,
} from "./constants";
// Intended to pull the latest available event given a tradeFormId and
// ensure the new event's tradeStatus aligns with the proper trade event sequence

export async function validateTradeFormEventSequence(tradeFormId, newTradeFormEventStatus) {
  const response = await fetchTradeDataByTradeFormId(tradeFormId).then((res) => res.json());
  if (tradeFormStatusToNextValidStatus[response.latestTradeFormEvent.tradeStatus].includes(newTradeFormEventStatus)) {
    return "";
  }
  return "Invalid Action, try refreshing the page";
}

export const tradeFormStatusToNextValidStatus = {
  [STATUS_OFFERED]: [STATUS_RETRACTED, STATUS_DECLINED, STATUS_EXPIRED_EE, STATUS_SUBMITTED],
  [STATUS_SUBMITTED]: [STATUS_REFUSED, STATUS_APPROVED, STATUS_EXPIRED_ADM],
  [STATUS_APPROVED]: [STATUS_CANCEL_OFFERED, STATUS_CANCELED_ADM],
  [STATUS_CANCEL_OFFERED]: [
    STATUS_CANCELED_ADM,
    STATUS_CANCEL_SUBMITTED,
    STATUS_CANCEL_DECLINED,
    STATUS_CANCEL_EXPIRED_EE,
  ],
  [STATUS_CANCEL_SUBMITTED]: [STATUS_CANCEL_REFUSED, STATUS_CANCEL_EXPIRED_ADM, STATUS_CANCELED_EE],
  [STATUS_CANCEL_DECLINED]: [STATUS_APPROVED],
  [STATUS_CANCEL_REFUSED]: [STATUS_APPROVED],
  [STATUS_CANCEL_EXPIRED_ADM]: [STATUS_APPROVED],
  [STATUS_CANCEL_EXPIRED_EE]: [STATUS_APPROVED],
  [STATUS_EXPIRED_ADM]: [STATUS_APPROVED],
  [STATUS_CANCELED_EE]: [],
  [STATUS_CANCELED_ADM]: [],
  [STATUS_REFUSED]: [],
  [STATUS_DECLINED]: [],
  [STATUS_RETRACTED]: [],
  [STATUS_EXPIRED_EE]: [],
};
